namespace GeniuzPOS.Common.Models {
    export interface UploadFileRequest extends Serenity.ServiceRequest {
        Date?: string;
        OriginalName?: string;
        FileName?: string;
        Username?: string;
    }
}
